import { Button, Flex, Heading, Spinner } from "@chakra-ui/react";
import { signIn } from "next-auth/react";
import SpinnerFull from "../../../components/spinner-full";
import { useAuthB2BRedirect } from "../../../hooks/use-auth-b2b-redirect";
import { useUser } from "../../../hooks/use-user";
import { authTarget } from "../../../types/constants";

export default function Authentication() {
  const { userIsLoading } = useUser(false);
  const { isLoading } = useAuthB2BRedirect();

  const onSignup = () => {
    signIn(authTarget, undefined);
  };

  if (userIsLoading || isLoading) {
    return <SpinnerFull />;
  }

  return (
    <Flex
      flexDir={"column"}
      h={"500px"}
      maxW="500px"
      margin="0 auto"
      p={5}
      justifyContent={"center"}
      alignItems={"center"}
    >
      {userIsLoading && <Spinner />}

      <Flex
        border="1px solid"
        borderColor="brand.gray.200"
        flexDir={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        p={{ base: 5, md: 12 }}
        borderRadius={10}
        backgroundColor="white"
        boxShadow={"lg"}
      >
        <Flex flexDir={"column"} mb={10} textAlign="center">
          <Heading mb={2} fontSize="xl" lineHeight={1.2}>
            Please sign in to access your organization
          </Heading>
        </Flex>

        <Button colorScheme={"brand.secondary"} onClick={onSignup} mb={2}>
          Sign In
        </Button>
      </Flex>
    </Flex>
  );
}
